import React, { useEffect, useRef, useState } from 'react';
import { components } from 'react-select';
import { SimpleSelectInput } from '../common/components/Form/FormSelectInput';

const Menu = props => (
  <components.Menu
    {...props}
    innerProps={{
      ...props.innerProps,
      'data-placement': props.placement,
      'aria-hidden': props.selectProps.menuClosing || undefined,
    }}
  />
);

const Control = props => {
  const handleReopen = event => {
    if (props.selectProps.menuClosing) {
      event.preventDefault();
      event.stopPropagation();
      const input = event.currentTarget.querySelector('input');
      if (input) input.focus();
      props.selectProps.reopenMenu();
    }
  };

  return (
    <components.Control
      {...props}
      innerProps={{
        ...props.innerProps,
        onMouseDownCapture: handleReopen,
        onTouchEndCapture: handleReopen,
      }}
    />
  );
};

const QuestionFilterSelect = ({ id, value, options, onChange }) => {
  const [menuState, setMenuState] = useState('closed');
  const closeTimer = useRef(null);

  useEffect(() => () => clearTimeout(closeTimer.current), []);

  const openMenu = () => {
    clearTimeout(closeTimer.current);
    setMenuState('open');
  };
  const closeMenu = () => {
    if (menuState !== 'open') return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      setMenuState('closed');
      return;
    }
    setMenuState('closing');
    closeTimer.current = setTimeout(() => setMenuState('closed'), 140);
  };

  return (
    <SimpleSelectInput
      className={`qq-select qq-select--${menuState}`}
      classNamePrefix="qq-select"
      inputId={id}
      instanceId={id}
      options={options}
      value={options.find(option => option.value === value)}
      onChange={option => onChange(option.value)}
      isSearchable={false}
      isClearable={false}
      blurInputOnSelect={false}
      tabSelectsValue={false}
      menuPlacement="auto"
      menuIsOpen={menuState !== 'closed'}
      menuClosing={menuState === 'closing'}
      reopenMenu={openMenu}
      onMenuOpen={openMenu}
      onMenuClose={closeMenu}
      onKeyDown={event => {
        if (menuState === 'closing' && ['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
          event.preventDefault();
          openMenu();
        }
      }}
      components={{ Menu, Control }}
      accessibleColors
    />
  );
};

export default QuestionFilterSelect;
